import React, { useEffect, useRef, useState } from 'react'
import {Link} from 'react-router-dom'
import heroImg from '../../../assets/images/hero-img.jpg'

var imgWidth, topHeight

function HeroBody() {

  const [heroImgWidth, setHeroImgWidth] = useState(0)
  const [imgTopOffset, setImgTopOffset] = useState(0)
  const heroImgRef = useRef()

  useEffect(() => {
    setHeroImgWidth(heroImgRef.current.clientWidth)
    setImgTopOffset(heroImgRef.current.getBoundingClientRect().top - 60)
  }, [imgTopOffset, heroImgWidth])

  imgWidth = heroImgWidth
  topHeight = imgTopOffset

  return (
    <Link to="/about">
        <div className="container-fluid">
          <div className="img-container show-case">
              <img ref={heroImgRef} className='transition-width' src={heroImg} alt="" />
          </div>
        </div>
    </Link> 

  )
}

export {imgWidth, topHeight}

export default HeroBody